module.exports = __webpack_public_path__ + "img/mode2.19c163e4.png";